import { DOCUMENTS_LIST_WIDTH } from 'constants/documents';

export const getStyles = ({ palette }, { isView } = {}) => ({
  controlsWrapper: {
    padding: '10px 20px 10px',
    position: 'relative',
    zIndex: 10,
  },
  treeContainer: {
    overflow: 'hidden',
    display: isView ? 'flex' : 'none',
    flexDirection: 'column',
    height: '100%',
    width: `${DOCUMENTS_LIST_WIDTH}px`,
    minWidth: `${DOCUMENTS_LIST_WIDTH}px`,
    color: palette.common.white,
    borderRight: `1px solid ${palette.divider}`,
  },
});
